// src/firebase/config.js
// Configuración de Firebase para Cuaderno del Profesor

import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { FIREBASE_CONFIG } from '../config/constants';

const firebaseConfig = FIREBASE_CONFIG;

const requiredKeys = [
  'apiKey',
  'authDomain',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId'
];

const missingKeys = requiredKeys.filter((key) => !firebaseConfig?.[key]);
if (missingKeys.length > 0) {
  throw new Error(
    `[Firebase] Faltan variables de entorno: ${missingKeys
      .map((k) => `VITE_FIREBASE_${k.replace(/([A-Z])/g, '_$1').toUpperCase()}`)
      .join(', ')}`
  );
}

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

if (typeof window !== 'undefined' && window?.localStorage?.getItem('DEBUG_FIREBASE') === '1') {
  console.log('[Firebase] Config activo:', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    storageBucket: firebaseConfig.storageBucket
  });
}

// Inicializar servicios
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// OPCIONAL: Para desarrollo local con emuladores
// Descomenta estas líneas si usas Firebase Emulator Suite
/*
if (window.location.hostname === 'localhost') {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectStorageEmulator(storage, 'localhost', 9199);
}
*/

export default app;
